import { render, staticRenderFns } from "./podcastSuggestion.vue?vue&type=template&id=4796495f&scoped=true&"
import script from "./podcastSuggestion.vue?vue&type=script&lang=js&"
export * from "./podcastSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./podcastSuggestion.vue?vue&type=style&index=0&lang=css&"
import style1 from "./podcastSuggestion.vue?vue&type=style&index=1&id=4796495f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4796495f",
  null
  
)

export default component.exports